export const Bio = {
  name: "Malhar Kauthale",
  roles: [
    
    "Programmer",
    "Cloud Engineer",
    "Devops Engineer",

  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/MalharKt",
  resume:
    "https://drive.google.com/file/d/1f5P1Go8j9RwsY4xOpn43crp9ztkYeSXt/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/malharkauthale",
  insta: "https://www.instagram.com/malharkauthale/",
  
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "PHP",
        image:
          "https://www.php.net//images/logos/new-php-logo.svg",
      },
            {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
     
    ],
  },
  {
    title: "CLoud and OS",
    skills: [
      {
        name: "AWS",
        image:
          "https://banner2.cleanpng.com/20180817/eqe/kisspng-amazon-web-services-amazon-com-logo-configure-aws-cli-profiles-quickly-and-efficient-5b7790b2eef861.1437542515345624829788.jpg",
      },
      {
        name: "Azure",
        image:
          "https://www.c-sharpcorner.com/UploadFile/BlogImages/01232023170209PM/Azure%20Icon.png",
      },
      {
        name: "Linux",
        image:
          "https://www.svgrepo.com/show/448236/linux.svg",
      },
    ],
  },
  {
    title: "Devops",
    skills: [
      {
        name: "Git",
        image:
          "https://tse2.mm.bing.net/th?id=OIP.q0DQLwqov4XeEv1FvaWwwAHaHa&pid=Api&P=0&h=180",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },

      {
        name: "Docker",
        image:
          "https://banner2.cleanpng.com/20190209/gfx/kisspng-docker-application-software-microsoft-sql-server-c-docker-logo-media-social-icon-5c5f4f5cbe0f72.4290032315497501087785.jpg",
      },

      {
        name: "Kubernetes",
        image:
          "https://banner2.cleanpng.com/20180416/gdq/kisspng-kubernetes-docker-google-cloud-platform-logo-lxc-container-5ad44c5e675a30.2660434915238626224233.jpg",
      },

      {
        name: "Jenkins",
        image:
          "https://www.svgrepo.com/show/373699/jenkins.svg",
      },

      {
        name: "SonarQube",
        image:
          "https://logowik.com/content/uploads/images/sonarqube7722.logowik.com.webp",
      },

      {
        name: "Trivy",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShfXeJu--djHA3ZqjRHrxFpYeSa9_zyPhZww&s",
      },
      


      {
        name: "Terraform",
        image:
          "https://www.svgrepo.com/show/376353/terraform.svg",
      },
    ],
  },

  {
    title: "Monitoring",
    skills: [
      {
        name: "Prometheus",
        image:
          "https://www.svgrepo.com/show/354219/prometheus.svg",
      },
      {
        name: "Grafana",
        image:
          "https://www.svgrepo.com/show/353829/grafana.svg",
      },
    ],
  },
];


export const education = [
  {
    id: 0,
    img: "https://images.shiksha.com/mediadata/images/1588139847phpKflTFr.jpg",
    school: "D.Y.Patil Institute of MCA and Management , Akurdi",
    date: "  Nov 2022 - May 2024",
    grade: "7.8 CGPA",
    desc: "I am currently pursuing a Master's degree in Computer application at D.Y.Patil Institute of MCA and Management , Akurdi. I have completed 3 semesters and have a CGPA of 8.32. In the academic curriculum i have learn various subjects such as Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. where I am learning, improving skills and working on exciting projects.",
    degree: "Master of Computer Application",
  },
  {
    id: 1,
    img: "https://cache.careers360.mobi/media/colleges/social-media/logo/Logo_of_Chandmal_Tarachand_Bora_College_Shirur_Logo.jpg",
    school: "C. T. Bora Arts, Science & Commerce college, Shirur, Pune",
    date: "Apr 2019 - Apr 2022",
    grade: "8.69 CGPA",
    desc: "I completed my Bachelor's degree in Computer Science at C. T. Bora Arts, Science & Commerce college, Shirur. Where i learn programming languages and computer fundamental concepts and also various skills such as C, java, php, frontend technologies and so on",
    degree: "Bachelor of Technology - B.sc., Computer Science and Engineering",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/C560BAQFETkyY9RMXcQ/company-logo_200_200/0/1630626823835?e=2147483647&v=beta&t=L9lLGASHuh2NSXoJs1xEQ-PuBU3IpI1okML7iY-mIic",
    school: "Vidyadham Junior College , Shirur, Pune",
    date: "Apr 2017 - Apr 2019",
    grade: "71.0%",
    desc: "I completed my class 12 high school education at Vidyadham Junior College , Shirur. where I studied Science with PCM Group.",
    degree: "HSC(XII), Science with PCM Group",
  },
  {
    id: 3,
    img: "https://lh5.googleusercontent.com/p/AF1QipMueBYTDzFi_Qm5VDd-ON00faoHipDEotGW8GIq=h100-k-no",
    school: "R.M.Dhariwal English Medium School , Shirur, Pune.",
    date: "Apr 2016 - Apr 2017",
    grade: "79.0%",
    desc: "I completed my class 10 education at R.M.Dhariwal English Medium School , Shirur. where I completed my secondary education",
    degree: "SSC(X), Science",
  },
];

export const projects = [
  {
    id: 0,
    title: "Three-Tier-App-Deployment-On-AWS",
    date: "Nov 2022 - Mar 2023",
    description:
      "Deployed a three-tier application on AWS using Docker, ECR, and Kubernetes. Configured Ingress controllers and load balancers for traffic routing, and mapped a custom domain to ensure seamless accessibility and scalability. ",
    image:
      "https://raw.githubusercontent.com/MalharKt/Three-Tier-App/master/Three-Tier-App-Screenshot.png",
    tags: ["React","Node js","Mongo DB", "AWS", "Docker", "Kubernetes","ECR", "Domain"],
    category: "web app",
    github: "https://github.com/MalharKt/Three-Tier-App",
  },

  {
    id: 1,
    title: "Turf-Booking-system",
    date: "Nov 2022 - Mar 2023",
    description:
      " The Turf Booking system is Python based application Project. The proposed system is developed to manage turf booking activities in different regions. These systems will ultimately allow you to better manage resources ",
    image:
      "https://raw.githubusercontent.com/MalharKt/Turf-Booking-System/master/TurfBooking/turf-booking-home-Screenshot.png",
    tags: ["Html & Css",  "Bootstrap", "Python", "MYSQL"],
    category: "web app",
    github: "https://github.com/MalharKt/Turf-Booking-System/tree/master/TurfBooking",
  },
  {
    id: 2,
    title: "Car-Parts-Reconnition-System",
    date: "Jun 2023 - Nov 2023",
    description:
        "The Car-Parts-Recognition-System has been developed to enchance searching of the car parts efficiently. This system improves the method of parts management. This system also provides a report generation system in which user can generate weekly, monthly, yearly reports.",
    image:
      "https://raw.githubusercontent.com/MalharKt/Car-Parts-Recognition-Webapp/master/static/Car-Parts-Home-Screenshot.png",
    tags: ["Html", "CSS", "Javascript", "Python", "MYSQL"],
    category: "web app",
    github: "https://github.com/MalharKt/Car-Parts-Recognition-Webapp/tree/master",
  },
 
 
];
